import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import axios from "axios";
import { toast } from "react-toastify";
import Cookies from "js-cookie";
import { adminMainUrl } from "../../../../../Config";

const ContactInfoEdit = ({ LedgerAccountDetail, refreshLedger }) => {

    const [countries, setCountries] = useState([]);
    const [states, setStates] = useState({});
    const [cities, setCities] = useState({});

    useEffect(() => {
        fetchCountries();
    }, []);

    const fetchCountries = async () => {
        const res = await axios.get(`${adminMainUrl}/api/country/list`);
        setCountries(res.data.data || []);
    };

    const fetchStates = async (countryId, index) => {
        const res = await axios.get(
            `${adminMainUrl}/api/state/list?country_id=${countryId}`
        );

        setStates((prev) => ({
            ...prev,
            [index]: res.data.data || [],
        }));
    };

    const fetchCities = async (stateId, index) => {
        const res = await axios.get(
            `${adminMainUrl}/api/city/list?state_id=${stateId}`
        );

        setCities((prev) => ({
            ...prev,
            [index]: res.data.data || [],
        }));
    };

    const formik = useFormik({
        enableReinitialize: true,

        initialValues: {
            contacts:
                LedgerAccountDetail?.ledger_account_contacts?.length > 0
                    ? LedgerAccountDetail.ledger_account_contacts.map((item) => ({
                        id: item.id,
                        contact_person: item.contact_person,
                        mobile_number: item.mobile_number,
                        email: item.email,
                        country: item.country_id || "",
                        state: item.state_id || "",
                        city: item.city_id || "",
                        pincode: item.pincode,
                        address: item.address,
                    }))
                    : [
                        {
                            id: "",
                            contact_person: "",
                            mobile_number: "",
                            email: "",
                            country: "",
                            state: "",
                            city: "",
                            pincode: "",
                            address: "",
                        },
                    ],
        },

        onSubmit: async (values) => {
            try {

                const formattedContacts = values.contacts.map((contact) => ({
                    id: contact.id,
                    contact_person: contact.contact_person,
                    mobile_number: contact.mobile_number,
                    email: contact.email,
                    pincode: contact.pincode,
                    address: contact.address,

                    country_id: contact.country,
                    state_id: contact.state,
                    city_id: contact.city
                }));

                const payload = {
                    ledger_account_id: LedgerAccountDetail.id,
                    contact: formattedContacts,
                };

                await axios.post(
                    `${adminMainUrl}/api/account/update-ledger-account-contact-info-details`,
                    payload,
                    {
                        headers: {
                            "Content-Type": "application/json",
                            "auth-token": Cookies.get("token"),
                            user_id: Cookies.get("flexichain_user_id"),
                        },
                    }
                )
                    .then((res) => {
                        if (res.status === 200) {
                            toast.success(res.data.msg);
                            refreshLedger(LedgerAccountDetail.id)
                        }
                    })
                    .catch((err) => {
                        let err_msg = err.message
                        // console.log(err)
                        if (err && err.response && err.response.data && err.response.data.msg) {
                            err_msg = err.response.data.msg;
                        }
                        toast.error(err_msg);
                    });

            } catch {
                toast.error("Update failed");
            }
        },
    });

    useEffect(() => {
        const loadDependentData = async () => {

            if (!LedgerAccountDetail?.ledger_account_contacts) return;

            const updatedContacts = [...formik.values.contacts];

            for (let index = 0; index < LedgerAccountDetail.ledger_account_contacts.length; index++) {

                const contact = LedgerAccountDetail.ledger_account_contacts[index];

                updatedContacts[index].country = contact.country_id || "";

                if (contact.country_id) {

                    const stateRes = await axios.get(
                        `${adminMainUrl}/api/state/list?country_id=${contact.country_id}`
                    );

                    const stateList = stateRes.data.data || [];

                    setStates((prev) => ({
                        ...prev,
                        [index]: stateList,
                    }));

                    const validState = stateList.find((s) => s.id === contact.state_id);
                    updatedContacts[index].state = validState ? contact.state_id : "";

                    if (validState) {

                        const cityRes = await axios.get(
                            `${adminMainUrl}/api/city/list?state_id=${contact.state_id}`
                        );

                        const cityList = cityRes.data.data || [];

                        setCities((prev) => ({
                            ...prev,
                            [index]: cityList,
                        }));

                        const validCity = cityList.find((c) => c.id === contact.city_id);
                        updatedContacts[index].city = validCity ? contact.city_id : "";
                    }
                }
            }

            formik.setFieldValue("contacts", updatedContacts);
        };

        loadDependentData();
    }, [LedgerAccountDetail]);

    const addContact = () => {
        formik.setFieldValue("contacts", [
            ...formik.values.contacts,
            {
                id: "",
                contact_person: "",
                mobile_number: "",
                email: "",
                country: "",
                state: "",
                city: "",
                pincode: "",
                address: "",
            },
        ]);
    };

    const removeContact = (index) => {

        if (formik.values.contacts.length > 1) {

            const updated = [...formik.values.contacts];
            updated.splice(index, 1);

            formik.setFieldValue("contacts", updated);
        }
    };

    return (
        <form onSubmit={formik.handleSubmit}>

            {formik.values.contacts.map((contact, index) => (

                <div key={index} className="border p-3 mb-3">

                    <div className="row">

                        <div className="col-md-4 mb-3">
                            <label className="form-label">Contact Person</label>
                            <input
                                type="text"
                                className="form-control"
                                name={`contacts.${index}.contact_person`}
                                value={contact.contact_person}
                                onChange={formik.handleChange}
                            />
                        </div>

                        <div className="col-md-4 mb-3">
                            <label className="form-label">Mobile Number</label>
                            <input
                                type="text"
                                className="form-control"
                                name={`contacts.${index}.mobile_number`}
                                value={contact.mobile_number}
                                onChange={formik.handleChange}
                            />
                        </div>

                        <div className="col-md-4 mb-3">
                            <label className="form-label">Email</label>
                            <input
                                type="email"
                                className="form-control"
                                name={`contacts.${index}.email`}
                                value={contact.email}
                                onChange={formik.handleChange}
                            />
                        </div>

                        <div className="col-md-4 mb-3">
                            <label className="form-label">Country</label>
                            <select
                                className="form-select"
                                value={contact.country || ""}
                                onChange={(e) => {

                                    const countryId = e.target.value;

                                    formik.setFieldValue(`contacts.${index}.country`, countryId);
                                    formik.setFieldValue(`contacts.${index}.state`, "");
                                    formik.setFieldValue(`contacts.${index}.city`, "");

                                    fetchStates(countryId, index);
                                }}
                            >
                                <option value="">Select</option>

                                {countries.map((c) => (
                                    <option key={c.id} value={c.id}>
                                        {c.name}
                                    </option>
                                ))}
                            </select>
                        </div>

                        <div className="col-md-4 mb-3">
                            <label className="form-label">State</label>
                            <select
                                className="form-select"
                                value={contact.state || ""}
                                onChange={(e) => {

                                    const stateId = e.target.value;

                                    formik.setFieldValue(`contacts.${index}.state`, stateId);
                                    formik.setFieldValue(`contacts.${index}.city`, "");

                                    fetchCities(stateId, index);
                                }}
                            >
                                <option value="">Select</option>

                                {(states[index] || []).map((s) => (
                                    <option key={s.id} value={s.id}>
                                        {s.name}
                                    </option>
                                ))}
                            </select>
                        </div>

                        <div className="col-md-4 mb-3">
                            <label className="form-label">City</label>
                            <select
                                className="form-select"
                                name={`contacts.${index}.city`}
                                value={contact.city || ""}
                                onChange={formik.handleChange}
                            >
                                <option value="">Select</option>

                                {(cities[index] || []).map((c) => (
                                    <option key={c.id} value={c.id}>
                                        {c.name}
                                    </option>
                                ))}
                            </select>
                        </div>

                        <div className="col-md-4 mb-3">
                            <label className="form-label">Pincode</label>
                            <input
                                type="text"
                                className="form-control"
                                name={`contacts.${index}.pincode`}
                                value={contact.pincode}
                                onChange={formik.handleChange}
                                maxLength={6}
                            />
                        </div>

                        <div className="col-md-8 mb-3">
                            <label className="form-label">Address</label>
                            <input
                                type="text"
                                className="form-control"
                                name={`contacts.${index}.address`}
                                value={contact.address}
                                onChange={formik.handleChange}
                            />
                        </div>

                    </div>

                    <button
                        type="button"
                        className="btn btn-danger mt-2"
                        onClick={() => removeContact(index)}
                    >
                        Delete Contact
                    </button>

                </div>
            ))}

            <button
                type="button"
                className="btn btn-primary btn-sm"
                onClick={addContact}
            >
                + Add More Contact
            </button>

            <div className="mt-4">
                <button type="submit" className="btn btn-primary" style={{ float: "right" }}>
                    Save
                </button>
            </div>

        </form>
    );
};

export default ContactInfoEdit;